import '/home/runner/work/figmayo-ui/figmayo-ui/.storybook/manager.js';